import { performRequestThird } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { getTenantDetails } from 'utils/utils';

export const getPendingLeadIntakeService = (params) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.intakeForm.listLeadIntakes}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${params ? `&${params}` : ''}`;
  return performRequestThird(apiEndPoints.methodType.GET, url);
};

export const deleteRejectedLeadIntakeService = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.intakeForm.deleteLeadIntake}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestThird(apiEndPoints.methodType.DELETE, url, data);
};

export const saveLeadIntakeService = (data, params) => {
  let url = `${apiEndPoints.intakeForm.saveLeadIntake}${params ? `?${params}` : ''}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data, null, false, false);
};

export const fetchLeadIntakeService = (params) => {
  let url = `${apiEndPoints.intakeForm.getLeadForm}${params ? `?${params}` : ''}`;
  return performRequestThird(apiEndPoints.methodType.GET, url, null, null, false, false);
};

export const getGeneralList = (params) => {
  let url = `${apiEndPoints.intakeForm.getGeneralList}${params ? `?${params}` : ''}`;
  return performRequestThird(apiEndPoints.methodType.GET, url, null, null, false);
};

/**
 * Fetch additional lead details for a specific lead
 * @param {string} tenantId - Tenant ID
 * @param {string} leadId - Lead ID/SK
 * @param {string} leadType - Lead type (online or capturenow)
 * @returns {Promise} API response
 */
export const getLeadDetailsService = (tenantId, leadId, leadType) => {
  if (!tenantId || !leadId || !leadType) {
    return Promise.reject(new Error('Missing required parameters: tenantId, leadId, or leadType'));
  }

  return performRequestThird('GET', `${apiEndPoints.getPendingLead}?tenant_id=${tenantId}&lead_id=${leadId}&lead_type=${leadType}`);
};
